<template>
  <div class="home-percentajes">
    <div class="pdv-container bg-main">
      <div class="home-percentajes-content">
        <div class="flex-1">
          <div class="card-yellow">
            <p class="card-yellow-title only-desktop">100% de nuestras sedes</p>
            <p class="card-yellow-text only-desktop">
              obtuvieron puntajes Máximos
            </p>
            <p class="card-yellow-text only-desktop">Nacionales</p>
            <p class="card-yellow-text-alt only-mobileBlock">
              <strong>100% de nuestras sedes </strong> obtuvieron puntajes Máximos Nacionales
            </p>

            <div class="badge-morado">
              <p>{{ endValOne }}%</p>
            </div>
          </div>
        </div>

        <div class="flex-1">
          <div class="card-yellow">
            <p class="card-yellow-title only-desktop">
              Más de 500 Puntajes Máximos Nacionales
            </p>
            <p class="card-yellow-text only-desktop">
              se prepararon con nosotros
            </p>
            <p class="card-yellow-text-alt only-mobileBlock">
              <strong>Más de 500 Puntajes Máximos Nacionales</strong> se prepararon con nosotros
            </p>
            <div class="badge-morado">
              <p>+{{ endValTwo }}</p>
            </div>
          </div>
        </div>
        <div class="flex-1">
          <div class="card-yellow">
            <p class="card-yellow-title only-desktop">
              El 83% de los Triples Máximos Nacionales
            </p>
            <p class="card-yellow-text only-desktop">
              se prepararon en Preu PDV
            </p>
            <p class="card-yellow-text-alt only-mobileBlock">
              <strong>El 83% de los Triples Máximos Nacionales </strong> se prepararon en Preu PDV
            </p>

            <div class="badge-morado">
              <p>{{ endValThree }}%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img
      src="/images/featured/esquina-isquierda-mobile.svg"
      style="width: 100%"
      alt="triangle"
      class="only-mobile"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      endValOne: 0,
      endValTwo: 0,
      endValThree: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ",",
        decimal: ".",
        prefix: "",
        suffix: "",
      },
    };
  },

  methods: {
    onReady() {
      this.endValOne = 100;
      this.endValTwo = +500;
      this.endValThree = 83;
    },
  },
  mounted() {
    this.onReady();
  },
};
</script>

<style lang="scss" scoped>
.home-percentajes {
  width: 100%;
  position: relative;

  .bg-main {
    @media (max-width: 768px) {
      padding: 40px 0;
      background: $amarrillo05;
    }
    @media (min-width: 769px) {
      padding: 64px 0;
    }
  }

  .home-percentajes-content {
    display: flex;
    justify-content: center;
    @media (max-width: 768px) {
      margin: 0 24px;
      flex-direction: column;
      gap: 62px;
    }
    @media (min-width: 769px) {
      padding: 0 76px;
      flex-direction: row;
      gap: 32px;
    }

    .flex-1 {
      width: 100%;
      max-width: 280px;
      margin: 0 auto;
    }

    .card-yellow {
      background: $amarrillo50;
      border-radius: 8px;
      position: relative;
      display: flex;
      width: 100%;
      height: 160px;

      &.first-card {
        .card-yellow-text-alt {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
      }

      @media (max-width: 768px) {
        padding: 12px 72px 12px 12px;
        flex-direction: row;
        height: 120px;
      }
      @media (min-width: 769px) {
        padding: 20px 80px 20px 20px;
        flex-direction: column;
      }
      .card-yellow-title {
        color: $colorTerciario;
        font-family: "Poppins-Bold", sans-serif;
        margin-bottom: 2px;
        max-width: 100%;
        word-wrap: break-word;

        @media (max-width: 768px) {
          font-size: 14px;
          line-height: 22px;
          margin-bottom: 1px;
        }
        @media (min-width: 769px) {
          font-size: 18px;
          line-height: 26px;
        }
      }
      .card-yellow-text {
        color: $colorTerciario;
        margin-bottom: 0;
        font-family: "Poppins-Regular", sans-serif;
        white-space: nowrap;
        @media (max-width: 768px) {
          display: none;
          font-size: 14px;
          line-height: 22px;
        }
        @media (min-width: 769px) {
          font-size: 16px;
          line-height: 24px;
        }
      }
      .card-yellow-text-alt {
        color: $colorTerciario;
        font-size: 16px;
        line-height: 22px;
        font-family: "Poppins-Regular", sans-serif;
        margin-bottom: 0;

        p {
          margin-bottom: 0;
        }

        .bold {
          font-weight: bold;
        }

        @media (min-width: 769px) {
          display: none;
        }
      }
      .badge-morado {
        position: absolute;
        background: $morado20;
        border-top-left-radius: 20px;
        border-bottom-right-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: solid 3px #ffffff;

        @media (max-width: 768px) {
          width: 90px;
          padding: 8px 12px;
          right: -45px;
          top: -25px;
        }
        @media (min-width: 769px) {
          right: -78px;
          top: -25px;
          width: 156px;
          padding: 8px 12px;
        }

        p {
          color: $neutralwhite;
          margin-bottom: 0;
          font-family: "Poppins-Bold", sans-serif;
          font-size: 32px;
          line-height: 40px;
          @media (max-width: 768px) {
            font-size: 28px;
            line-height: 36px;
          }
        }
      }
    }
  }
}
</style>
